import * as materials from "materials/index"
console.log("materials.",materials)
class MutationLoader {
  constructor() {
    this.menuMaps = {
      app: [],
      portal: [],
      bigScreen: []
    }
    this.menuCache = {}
    this.componentsMap = materials
    this.components = Object.values(materials)
    this.components.forEach(component => {
      Object.entries(component.menus || {}).forEach(([key, value]) => {
        this.menuMaps[key] && this.menuMaps[key].push(...value)
      })
    })
  }
  addMaterial(type, comp) {
    this.componentsMap[type] = comp
  }
  // 获取toolbar数据
  getToolBarMixins() {
    const mixins = {}
    const menuConfig = {}
    this.components.forEach(comp => {
      const { toolbars } = comp
      if (toolbars) {
        toolbars.forEach(toolComp => {
          const { name, label, parentMenuName, comp, config } = toolComp || {}
          if (!name) return
          menuConfig[name] = {
            name,
            label,
            parentMenuName,
            config
          }
          comp &&
            Object.entries(comp).forEach(([key, renderComp]) => {
              mixins[key] = renderComp
            })
        })
      }
    })
    return { mixins, menuConfig }
  }
  getMenuResources(menuConfig, stageType, params, groupId) {
    const config = menuConfig.find(item => item.type === groupId)
    if (!config) return []
    const compoents = config.components(stageType, params)
    return this.getMenuDatasByComponents(compoents, stageType, params)
  }
  // 获取components对应的菜单数据
  getMenuDatasByComponents(components, stageType, params) {
    const targetMenuDatas = {}
    components.forEach(comp => {
      if (typeof comp === "object") {
        // 如果是对象则表示是自定义的
        const { name, children, type } = comp
        const targetComponent = this.componentsMap[type]
        targetMenuDatas[type + name] = {
          name: name ? name : targetComponent?.name,
          children: children ? children : targetComponent?.childrens?.default?.[stageType],
          type,
          id: ""
        }
      } else {
        // 不是对象则表示默认
        const targetComponent = this.componentsMap[comp]
        if (targetComponent) {
          const { name, type } = targetComponent
          targetMenuDatas[type + name] = { name, type, children: targetComponent?.childrens?.default?.[stageType] }
        }
      }
    })
    return targetMenuDatas
  }
  getAllOptDes() {
    const optDesObj = {}
    this.components.forEach(comp => {
      const { name: shape, optDes } = comp
      optDes && (optDesObj[`get${shape[0].toUpperCase() + shape.slice(1)}OptDes`] = optDes)
    })
    return optDesObj
  }
  // 获取全部组件mixins
  getAllRenderComponentsMixin() {
    const mixins = {}
    this.components.forEach(comp => {
      const { name, render } = comp
      mixins[name] = render
    })
    console.log("mixins", mixins)
    return mixins
  }
  // 根据组件名获取mixins集合
  getRenderComponentsMixin(componentTypes = []) {
    const mixin = {}
    componentTypes.forEach(componentType => {
      const targetComponent = this.componentsMap[componentType]
      if (targetComponent) {
        mixin[componentType] = targetComponent.render
      }
    })
    return mixin
  }
  // 根据页面类型(大屏/2.0/app)和分组类型，获取对应的组件集合
  getMenusByStageAndGroup(stageType, groupName) {
    const targerMenuStates = {}
    let sortComponents = this.components
    sortComponents.map(comp => {
      const { menus, name } = comp
      if (menus[stageType]) {
        menus[stageType].forEach(menu => {
          let { name: menuName, enable, type, children, group } = menu
          if (group == groupName) {
            targerMenuStates[name + menuName] = { ...menu, type: type ? type : name, children, enable: enable ?? true }
          }
        })
      }
    })
    return targerMenuStates
  }
  getMenuStates(stageType, params, includeComponents) {
    const targerMenuStates = {}
    let sortComponents = []
    if (includeComponents) {
      includeComponents.forEach(item => {
        if (this.componentsMap[item]) {
          sortComponents.push(this.componentsMap[item])
        }
      })
    } else {
      sortComponents = this.components
    }
    sortComponents &&
      sortComponents.map(comp => {
        const { menus, name } = comp
        if (menus[stageType]) {
          menus[stageType].forEach(menu => {
            let { name: menuName, enable, type, children } = menu
            if (typeof children === "function") {
              children = children(params)
            }
            if (enable && typeof enable === "function") {
              enable(params) && (targerMenuStates[name + menuName] = { ...menu, type: type ? type : name, children })
            } else if (enable === undefined || enable === null) {
              targerMenuStates[name + menuName] = { ...menu, type: type ? type : name, children }
            }
          })
        }
      })
    return targerMenuStates
  }
  // 获取对应组件类型和平台下的menus children数据
  getMenuChildByTypeOrName({ type, name, stageType, typeId,needCompareName }) {
    if (type && this.menuCache[type + stageType]) return this.menuCache[type + stageType]
    if (typeId && this.menuCache[typeId + stageType]) return this.menuCache[typeId + stageType]
    let resultMenu = null
    const stageMap = {
      appStage: "app",
      bigScreen: "bigScreen",
      stage: "portal"
    }
    // 先通过组件类型查找
    const targetMenu = this.componentsMap[type]
    if (targetMenu) {
      resultMenu = targetMenu?.menus?.[stageMap[stageType]][0]
      resultMenu && (this.menuCache[type + stageType] = resultMenu)
    }
    if (!resultMenu) {
      resultMenu =
        this.menuMaps[stageMap[stageType]] &&
        this.menuMaps[stageMap[stageType]].find(item => {
          if (item.type === type) {
            this.menuCache[type + stageType] = item
            return true
          }
          if (typeId && typeId === item.typeId) {
            this.menuCache[typeId + stageType] = item
            return true
          }
          return false
        })
    }
    return resultMenu
  }
}

const materialLoader = new MutationLoader()
const toolbarMixins = materialLoader.getToolBarMixins()
const componentsMixins = materialLoader.getAllRenderComponentsMixin()

export { materialLoader, toolbarMixins, componentsMixins }
